module.exports = __webpack_public_path__ + "static/media/ESTP.fb2b553e.png";